// extracted by mini-css-extract-plugin
export default {"columnLink":"prescription-report_columnLink__cm+Zc","actionLink":"prescription-report_actionLink__u-geh","rejectionContainer":"prescription-report_rejectionContainer__qFUFI"};